import { noop } from '@utils/noop';
import { UseFormReturn } from 'react-hook-form';
import { ObjectSchema, object, string } from 'yup';
import { Dispatch, createContext, useContext } from 'react';

export type CreateAviatorPermissionFormState = {
  permission: string;
};

export const createAviatorPermissionFormStateDefault: CreateAviatorPermissionFormState = {
  permission: '',
};

export const createAviatorPermissionSchemaDefault: ObjectSchema<
  Partial<CreateAviatorPermissionFormState>
> = object<Partial<CreateAviatorPermissionFormState>>().shape({
  permission: string().required('Permission is required field'),
});

type CreateAviatorPermissionFormContextType = {
  schema: ObjectSchema<Partial<CreateAviatorPermissionFormState>>;
  setSchema: Dispatch<ObjectSchema<Partial<CreateAviatorPermissionFormState>>>;
  methods?: UseFormReturn<CreateAviatorPermissionFormState>;
};

const createAviatorPermissionFormContextDefault = {
  schema: createAviatorPermissionSchemaDefault,
  setSchema: noop,
} satisfies CreateAviatorPermissionFormContextType;

export const CreateAviatorPermissionFormContext =
  createContext<CreateAviatorPermissionFormContextType>(createAviatorPermissionFormContextDefault);

export const useCreateAviatorPermissionForm = () => {
  const { methods } = useContext(CreateAviatorPermissionFormContext);
  if (!methods) {
    throw new Error('CreateAviatorPermissionFormContext is empty');
  }

  return methods;
};

export const useManageCreateAviatorPermissionSchema = () => {
  const { setSchema } = useContext(CreateAviatorPermissionFormContext);

  return { setSchema };
};
